import { createAction } from 'redux-actions';
import { createDeferredAction } from '../../utils/redux';
import {
  BEGIN, CLEAR, FAILED, SUCCESSFUL,
} from '../../configs/actionNames';
import { FILTER_TEMPLATE_MODULE } from '../../configs/moduleNames';

export const LOAD_FILTER_TEMPLATE_LIST = '_LOAD_FILTER_TEMPLATE_LIST';
export const LOAD_FILTER_TEMPLATE_BY_ID = '_LOAD_FILTER_TEMPLATE_BY_ID';
export const CREATE_FILTER_TEMPLATE = '_CREATE_FILTER_TEMPLATE';
export const UPDATE_FILTER_TEMPLATE = '_UPDATE_FILTER_TEMPLATE';
export const DELETE_FILTER_TEMPLATE = '_DELETE_FILTER_TEMPLATE';

export const loadFilterTemplateList = createDeferredAction(FILTER_TEMPLATE_MODULE + LOAD_FILTER_TEMPLATE_LIST);
export const loadFilterTemplateListSuccessful = createAction(FILTER_TEMPLATE_MODULE + LOAD_FILTER_TEMPLATE_LIST + SUCCESSFUL);
export const loadFilterTemplateListBegin = createAction(FILTER_TEMPLATE_MODULE + LOAD_FILTER_TEMPLATE_LIST + BEGIN);
export const loadFilterTemplateListFailed = createAction(FILTER_TEMPLATE_MODULE + LOAD_FILTER_TEMPLATE_LIST + FAILED);

export const loadFilterTemplateById = createDeferredAction(FILTER_TEMPLATE_MODULE + LOAD_FILTER_TEMPLATE_BY_ID);
export const loadFilterTemplateByIdSuccessful = createAction(FILTER_TEMPLATE_MODULE + LOAD_FILTER_TEMPLATE_BY_ID + SUCCESSFUL);
export const loadFilterTemplateByIdFailed = createAction(FILTER_TEMPLATE_MODULE + LOAD_FILTER_TEMPLATE_BY_ID + FAILED);
export const loadFilterTemplateByIdClear = createAction(FILTER_TEMPLATE_MODULE + LOAD_FILTER_TEMPLATE_BY_ID + CLEAR);

export const createFilterTemplate = createDeferredAction(FILTER_TEMPLATE_MODULE + CREATE_FILTER_TEMPLATE);
export const createFilterTemplateSuccessful = createAction(FILTER_TEMPLATE_MODULE + CREATE_FILTER_TEMPLATE + SUCCESSFUL);
export const createFilterTemplateFailed = createAction(FILTER_TEMPLATE_MODULE + CREATE_FILTER_TEMPLATE + FAILED);

export const updateFilterTemplate = createDeferredAction(FILTER_TEMPLATE_MODULE + UPDATE_FILTER_TEMPLATE);
export const updateFilterTemplateSuccessful = createAction(FILTER_TEMPLATE_MODULE + UPDATE_FILTER_TEMPLATE + SUCCESSFUL);
export const updateFilterTemplateFailed = createAction(FILTER_TEMPLATE_MODULE + UPDATE_FILTER_TEMPLATE + FAILED);

export const deleteFilterTemplate = createDeferredAction(FILTER_TEMPLATE_MODULE + DELETE_FILTER_TEMPLATE);
export const deleteFilterTemplateSuccessful = createAction(FILTER_TEMPLATE_MODULE + DELETE_FILTER_TEMPLATE + SUCCESSFUL);
export const deleteFilterTemplateFailed = createAction(FILTER_TEMPLATE_MODULE + DELETE_FILTER_TEMPLATE + FAILED);
